// @/components/auth/SessionTimeoutWarning.jsx
// Session timeout countdown dialog — closing counts as activity

import React, { useState, useEffect } from 'react';
import { Alert, AlertTitle, AlertDescription } from '@/components/reusable/alert';

const SessionTimeoutWarning = ({ open, onContinue, secondsRemaining = 120 }) => {
  const [timeLeft, setTimeLeft] = useState(secondsRemaining);

  useEffect(() => {
    if (open) {
      setTimeLeft(secondsRemaining);
      const interval = setInterval(() => {
        setTimeLeft(prev => {
          if (prev <= 1) { clearInterval(interval); return 0; }
          return prev - 1;
        });
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [open, secondsRemaining]);

  return (
    <Alert open={open} onClose={onContinue} size="xl">
      <AlertTitle>Session timeout</AlertTitle>
      <AlertDescription>
        <span className="font-bold">Your session is about to expire due to inactivity.</span>{' '}
        You will be automatically logged out in <span className="font-bold">{timeLeft} seconds</span>.
        {' '}Any activity will keep your session active.
      </AlertDescription>
    </Alert>
  );
};

export default SessionTimeoutWarning;
